import React, { useState, useContext, useEffect } from 'react';
import { Heart } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';
import { AuthContext } from '../App';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const FavoriteButton = ({ tutorialId, initialFavorited = false, size = 'default' }) => {
  const { user, token, setShowAuthModal } = useContext(AuthContext);
  const [isFavorited, setIsFavorited] = useState(initialFavorited);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user.favorites) {
      setIsFavorited(user.favorites.includes(tutorialId));
    }
  }, [user, tutorialId]);

  const toggleFavorite = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!token) {
      setShowAuthModal(true);
      return;
    }

    setLoading(true);

    try {
      if (isFavorited) {
        await axios.delete(`${API}/favorites/${tutorialId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setIsFavorited(false);
        toast.success('Retiré des favoris');
      } else {
        await axios.post(
          `${API}/favorites/${tutorialId}`,
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setIsFavorited(true);
        toast.success('Ajouté aux favoris');
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Une erreur est survenue');
    } finally {
      setLoading(false);
    }
  };

  const sizeClasses = {
    small: 'w-4 h-4',
    default: 'w-5 h-5',
    large: 'w-6 h-6'
  };

  const buttonSizeClasses = {
    small: 'p-2',
    default: 'p-3',
    large: 'p-4'
  };

  return (
    <button
      onClick={toggleFavorite}
      disabled={loading}
      data-testid={`favorite-btn-${tutorialId}`}
      className={`${buttonSizeClasses[size]} border gold-border hover:bg-primary hover:text-white hover:border-primary transition-all duration-300 bg-porcelain/90 backdrop-blur-sm ${
        isFavorited ? 'bg-primary text-white border-primary' : 'text-charcoal'
      } ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
      title={isFavorited ? 'Retirer des favoris' : 'Ajouter aux favoris'}
    >
      <Heart className={`${sizeClasses[size]} ${isFavorited ? 'fill-current' : ''}`} />
    </button>
  );
};

export default FavoriteButton;
